import React, { useEffect, useState } from 'react';
import { Modal, Col, Divider } from 'rsuite';
import globalIP from '@/GlobelIP';
import axios from 'axios';
import { handleDecrypt } from '@/functions';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './HomePages/home.css';
import { Grid, Row } from 'rsuite';
import { Icon } from '@rsuite/icons';
import ArrowLeftIcon from '@rsuite/icons/ArrowLeft';
import ArrowRightIcon from '@rsuite/icons/ArrowRight';
import useUser from '../../src/components/UseUser';
export default function ProductModal({
  modeldata,
  close,
  open,
  selectedItems,
  handleCheckboxChange,
  allQyeryData,
  attributesData,
  attributesName
}) {
  const { user } = useUser();
  const C_A_id = handleDecrypt(sessionStorage.getItem('E-C_A_id')); // C_A_id (Client Activity id)
  const [selectedImagePath, setSelectedImagePath] = useState({ url: '', id: '', default: true });
  const [imageList, setImageList] = useState([]);
  // useEffect(() => {
  //   if (modeldata) {
  //     fetchData1234();
  //   }
  // }, []);

  // const fetchData1234 = async () => {
  //   const extractedImageList = modeldata
  //     .filter(item => item.attributes.MultipleImage && item.attributes.MultipleImage.data)
  //     .map(item => item.attributes.MultipleImage.data
  //     .map(item => item.attributes.url))
  //     .flat(); // Flatten the array of arrays
  //   const coverImage = modeldata.map(item => item.attributes.CoverImage.data.attributes.url);
  //   extractedImageList.unshift(coverImage);
  //   console.log('coverImage;;;;' , coverImage);

  //   const prefixed_list = extractedImageList.map(file => globalIP + file);

  //   setImageList(prefixed_list);
  // };
  useEffect(() => {
    if (modeldata) {
      fetchData();
    }
  }, [open, modeldata]);
  const fetchData = async () => {
    try {
      const response = await axios.get(`${globalIP}/api/clientactivities/${C_A_id}?populate=*`);
      const openedProductData = response.data.data.attributes.openedproduct;
      // console.log(openedProductData, 'openedProductData');

      let updatedOpenedProductData;
      if (openedProductData) {
        updatedOpenedProductData = [
          ...openedProductData,
          {
            typecode: response.data.data.attributes.typecode,
            productid: String(modeldata[0].id),
            productcode: modeldata[0]?.attributes.ProductCode
          }
        ];
      } else {
        updatedOpenedProductData = [
          {
            typecode: response.data.data.attributes.typecode,
            productid: String(modeldata[0].id),
            productcode: modeldata[0]?.attributes.ProductCode
          }
        ];
      }
      const postData = await axios.put(`${globalIP}/api/clientactivities/${C_A_id}`, {
        data: {
          openedproduct: updatedOpenedProductData
        }
      });

      // console.log('Post Data:', postData);
    } catch (error) {
      console.error('Error fetching or updating data:', error);
    }
  };
  const capitalizeFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const exist = allQyeryData?.some(item => item?.productid == modeldata[0]?.id);

  const defaultImageIndex = 0; // Index of the default image
  const [selectedImageIndex, setSelectedImageIndex] = useState(defaultImageIndex); // Initial selected image index

  const handleNextImage = item => {
    setSelectedImageIndex(prevIndex => (prevIndex + 1) % imageList.length);
  };

  const handlePrevImage = item => {
    setSelectedImageIndex(prevIndex => (prevIndex - 1 + imageList.length) % imageList.length);
  };

  // useEffect(() => {
  //   console.log('imgindex : ' + selectedImageIndex);
  //   setSelectedImagePath({
  //     url: modeldata[0]?.attributes?.MultipleImage?.data[selectedImageIndex]?.attributes?.url,
  //     id: modeldata[0]?.id,
  //     default: true
  //   });
  // }, [selectedImageIndex]);

  const [sizeshow, setSizeShow] = useState(false);
  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${globalIP}/api/company-details`);
      const json = await response.json();
      const extractedData = json.data[0].attributes.FreeSize;
      setSizeShow(extractedData);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [showPricing, setShowPricing] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const {
        data: {
          data: { attributes }
        }
      } = await axios.get(
        `${globalIP}/api/client-logins/${sessionStorage.getItem('user_id')}?populate=*`
      );
      setShowPricing(
        attributes.showPricing == null || attributes.showPricing == false ? false : true
      );
    };
    fetchData();
  }, []);
  return (
    <Modal
      size={window.innerWidth >= 746 ? 'full' : 'calc(100% - -7px)'}
      open={open}
      onClose={close}
    >
      <Modal.Header>
        <Modal.Title style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h5>Product Details</h5>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: '0px' }}>
        <Swiper
          navigation={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }}
          pagination={{
            clickable: true
          }}
          modules={[EffectFade, Navigation]}
          className="mySwiper-1"
        >
          {modeldata.map((item, index) => {
            return (
              <SwiperSlide key={item.id}>
                <Grid fluid>
                  <Row>
                    <Col lg={12} xs={24}>
                      <div
                        style={{ zIndex: 10000 }}
                        className="arrow arrow-left"
                        onClick={() => handlePrevImage(item)}
                      >
                        <Icon as={ArrowLeftIcon} />
                      </div>
                      <div style={{ zIndex: 100 }} className="slide-main-image">
                        <img
                          style={{ width: '400px', height: '400px', objectFit: 'contain' }}
                          src={
                            selectedImagePath.url && selectedImagePath.id == item.id
                              ? `${globalIP}${selectedImagePath.url}`
                              : `${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`
                          }
                          alt=""
                          className="iiimge"
                        />
                        <div className="selected-button" style={{ zIndex: 100 }}>
                          <span className="heart-circle">
                            {!exist ? (
                              <div
                                onClick={() =>
                                  handleCheckboxChange(
                                    item.id,
                                    !selectedItems.includes(item.id),
                                    item.attributes.ProductCode
                                  )
                                }
                                style={{ display: 'flex' }}
                              >
                                {selectedItems.includes(item.id) ? (
                                  <svg className="heart" viewBox="0 0 32 29.6">
                                    <path
                                      d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2
	c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z"
                                    />
                                  </svg>
                                ) : (
                                  <span className="material-symbols-outlined">favorite</span>
                                )}
                              </div>
                            ) : (
                              <svg className="heart-1" viewBox="0 0 32 29.6">
                                <path
                                  d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2
	c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z"
                                />
                              </svg>
                            )}
                          </span>
                        </div>
                      </div>
                      <div
                        style={{ zIndex: 10000 }}
                        className="arrow1 arrow-right"
                        onClick={() => handleNextImage(item)}
                      >
                        <Icon as={ArrowRightIcon} />
                      </div>
                      {!item.attributes.MultipleImage.data && (
                        <div style={{ padding: '15px 15px' }}>
                          <Swiper
                            spaceBetween={20}
                            navigation={true}
                            slidesPerView={window.innerWidth >= 746 ? 6 : 3}
                            pagination={{ clickable: true }}
                            modules={[Navigation]}
                            className="nestedSwiper"
                          >
                            <SwiperSlide>
                              <div
                                style={{
                                  // height: '80px',
                                  borderRadius: '5px',
                                  overflow: 'hidden'
                                }}
                              >
                                <img
                                  src={`${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`}
                                  alt=""
                                  style={{ width: '100%', height: '100%' }}
                                  onClick={() =>
                                    setSelectedImagePath({
                                      url: item?.attributes?.CoverImage?.data?.attributes?.url,
                                      id: item.id,
                                      default: true
                                    })
                                  }
                                />
                              </div>
                            </SwiperSlide>
                          </Swiper>
                        </div>
                      )}
                      {item.attributes.MultipleImage.data && (
                        <div style={{ padding: '15px 10px' }}>
                          <Swiper
                            spaceBetween={20}
                            navigation={true}
                            slidesPerView={window.innerWidth >= 746 ? 6 : 3}
                            pagination={{ clickable: true }}
                            modules={[Navigation]}
                            className="nestedSwiper"
                          >
                            <SwiperSlide>
                              <div
                                style={{
                                  height: '80px',
                                  borderRadius: '5px',
                                  overflow: 'hidden'
                                }}
                                className={
                                  selectedImagePath.url ==
                                    item?.attributes?.CoverImage?.data?.attributes?.url &&
                                  selectedImagePath.id == item.id
                                    ? 'image-product-select image-product-select-active'
                                    : null
                                }
                              >
                                <img
                                  src={`${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`}
                                  alt=""
                                  style={{ width: '100%', height: '100%' }}
                                  onClick={() =>
                                    setSelectedImagePath({
                                      url: item?.attributes?.CoverImage?.data?.attributes?.url,
                                      id: item.id,
                                      default: true
                                    })
                                  }
                                />
                              </div>
                            </SwiperSlide>
                            {item.attributes.MultipleImage.data &&
                              item.attributes.MultipleImage.data.map(multiImage => {
                                return (
                                  <SwiperSlide key={multiImage.id}>
                                    <div
                                      style={{
                                        height: '80px',
                                        borderRadius: '5px',
                                        overflow: 'hidden'
                                      }}
                                      className={
                                        selectedImagePath.url == multiImage.attributes.url &&
                                        selectedImagePath.id == item.id
                                          ? 'image-product-select image-product-select-active'
                                          : null
                                      }
                                    >
                                      <img
                                        src={`${globalIP}${multiImage.attributes.url}`}
                                        alt=""
                                        style={{ width: '100%', height: '100%' }}
                                        onClick={() =>
                                          setSelectedImagePath({
                                            url: multiImage.attributes.url,
                                            id: item.id,
                                            default: true
                                          })
                                        }
                                      />
                                    </div>
                                  </SwiperSlide>
                                );
                              })}
                          </Swiper>
                        </div>
                      )}
                    </Col>

                    <Col lg={12} xs={24}>
                      <div style={{ padding: '10px 20px' }} className="slide-product-table">
                        {attributesData?.Cust_Productname && (
                          <div className="slide-product-name roboto-medium">
                            {item.attributes.ProductName}
                          </div>
                        )}
                        {(user.CATShwPrice === true || user.Category === 'Admin') &&
                          showPricing && (
                            <div className="slide-product-price ">
                              <div className="roboto-regular-italic">
                                {/* <span className="material-symbols-outlined">currency_rupee</span> */}
                                {item.attributes.SellingPrice || 0}{' '}
                                {item.attributes.SellingPriceCurrency || ''}
                              </div>
                            </div>
                          )}
                        {attributesData?.Cust_Description && (
                          <div className="slide-product-details ">
                            <span className="roboto-medium">Description</span>
                            <p className="roboto-regular">{item.attributes.Description}</p>
                          </div>
                        )}
                        <Divider style={{ margin: '10px 0' }} />
                        <div className="slide-product-details">
                          {sizeshow ? (
                            <div className="slide-product-size-range">
                              {/* <span className="roboto-medium">Free Size</span> */}
                              <p className="roboto-regular">{item.attributes.SizeRange}</p>
                            </div>
                          ) : (
                            <div className="slide-product-dimensions">
                              <span className="roboto-medium">Dimensions</span>
                              <p className="roboto-regular">
                                {item.attributes.Length} x {item.attributes.Width} x{' '}
                                {item.attributes.Height}
                                <span className="product-unit">
                                  {capitalizeFirstLetter(item.attributes.SizeUnit)}
                                </span>
                              </p>
                            </div>
                          )}
                        </div>
                        {attributesData?.Cust_Aliascode && (
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">
                              {attributesName?.AliasCode || 'Alias Code'}
                            </div>
                            <div>{item.attributes.ProductId}</div>
                          </div>
                        )}
                        {attributesData?.Cust_Category && (
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">
                              {attributesName?.Category || 'Category'}
                            </div>
                            <div>{item.attributes.CategoryName}</div>
                          </div>
                        )}
                        {attributesData?.Cust_Producttype && (
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">
                              {attributesName?.ProductType || 'Product Type'}
                            </div>
                            <div>{item.attributes.ProductTypeName}</div>
                          </div>
                        )}
                        {attributesData?.Cust_Finish && (
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">
                              {attributesName?.finish || 'Finish'}
                            </div>
                            <div>{item.attributes.FinishName}</div>
                          </div>
                        )}
                        {attributesData?.Cust_Color && (
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">{attributesName?.color || 'Color'}</div>
                            <div>{item.attributes.ColorName}</div>
                          </div>
                        )}
                        {sizeshow ? null : (
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">{attributesName?.cbm || 'CBM'}</div>
                            <div>{item.attributes.Total_CBM}</div>
                          </div>
                        )}
                        {/* {attributesData?.Cust_FreeSize && (
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">
                              {attributesName?.SizeRange || 'Free Size'}
                            </div>
                            <div>{item.attributes.SizeRange}</div>
                          </div>
                        )} */}
                        {attributesData?.Cust_GrsWgt && (
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">
                              {attributesName?.GrossWgt || 'Gross Weight'}
                            </div>
                            <div>{item.attributes.GrossWeight}</div>
                          </div>
                        )}
                        {attributesData?.Cust_NetWgt && (
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">
                              {attributesName?.NetWgt || 'Net Weight'}
                            </div>
                            <div>{item.attributes.NetWeight}</div>
                          </div>
                        )}
                        {!exist ? (
                          <div
                            onClick={() =>
                              handleCheckboxChange(
                                item.id,
                                !selectedItems.includes(item?.id),
                                item?.attributes.ProductCode
                              )
                            }
                          >
                            {selectedItems.includes(item?.id) ? (
                              <>
                                <div className="bottom-page-slide" style={{ textAlign: 'center' }}>
                                  <button
                                    className={
                                      selectedItems.includes(item?.id)
                                        ? 'select-button-1'
                                        : 'select-button'
                                    }
                                  >
                                    Selected
                                  </button>
                                </div>
                              </>
                            ) : (
                              <div className="bottom-page-slide" style={{ textAlign: 'center' }}>
                                <button
                                  className={
                                    selectedItems.includes(item?.id)
                                      ? 'select-button'
                                      : 'select-button'
                                  }
                                >
                                  Select Product
                                </button>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div>
                            {exist ? (
                              <>
                                <div className="bottom-page-slide" style={{ textAlign: 'center' }}>
                                  <button className={'select-button-2'}>Query sent</button>
                                </div>
                              </>
                            ) : (
                              <div className="bottom-page-slide" style={{ textAlign: 'center' }}>
                                <button
                                  className={
                                    selectedItems.includes(item?.id)
                                      ? 'select-button'
                                      : 'select-button'
                                  }
                                >
                                  Select Product
                                </button>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>
                </Grid>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </Modal.Body>
    </Modal>
  );
}
